import { useEffect, useState, createContext } from "react";
import axios from "axios";
import { apiEndPoint } from '../../environment'
import { useNavigate, useLocation } from "react-router-dom";
import jwtDecode from "jwt-decode";
import { toast } from 'react-toastify';

const LoginContext = createContext()

export { LoginContext }

const LoginProvider = ({ children }) => {

    const [user, setUser] = useState(() =>
        localStorage.getItem("tokens")
            ? jwtDecode(localStorage.getItem("tokens"))
            : null
    );

    const [tokens, setTokens] = useState(() =>
        localStorage.getItem("tokens") ? JSON.parse(localStorage.getItem("tokens")) : null
    )

    const [error, setErrors] = useState("");
    const [loadingLogin, setLoadingLogin] = useState(false);
    const [loading, setLoading] = useState(true);
    const [addSite, setAddSite] = useState(false);

    const arr = ['docs', 'auth']

    const location = useLocation()

    const locNavigate = location.pathname.split('/')[1]
    
    const navigate = useNavigate()

    const loginUser = (email, password) => {
        // e.preventDefault()
        setLoadingLogin(true)
        const config = {
            method: 'post',
            url: `${apiEndPoint}user/login`,
            headers: {
                "Content-Type": "application/json"
            },
            data: {
                // email: e.target.email.value,
                // password: e.target.password.value
                email: email,
                password: password
            }
        }
        axios(config).then((response) => {
            setTokens(response.data);
            setUser(jwtDecode(response.data.access));
            localStorage.setItem("tokens", JSON.stringify(response.data));
            navigate("/");
            setAddSite(true)
            setLoadingLogin(false)
            toast.success(`Sucess: ${response.data.message}`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
        }).catch((error) => {
            setErrors(error.response.data.message)
            setLoadingLogin(false)
            toast.error(`Error: ${error.response.data.message}`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
        })
    }

    const logoutUser = () => {
        setTokens(null);
        setUser(null);
        localStorage.removeItem("tokens");
        localStorage.removeItem("currentSideId");
        if (arr.indexOf(locNavigate) == -1) {
            navigate("/");
        }
    }

    const updateToken = () => {
        const config = {
            method: "post",
            url: `${apiEndPoint}user/refreshtoken`,
            headers: {
                "Content-Type": "application/json"
            },
            data: { refreshToken: tokens?.refresh }
        }
        axios(config).then((response) => {
            setTokens(response.data);
            setUser(jwtDecode(response.data.access));
            localStorage.setItem("tokens", JSON.stringify(response.data));
            setAddSite(true)
        }).catch((error) => {
            logoutUser()
        })

        if (loading) {
            setLoading(false)
        }
    }

    const contextData = {
        loginUser,
        user,
        error,
        loadingLogin,
        logoutUser,
        addSite
    }

    const thirtyMinute = 60 * 60 * 24

    useEffect(() => {
        if (loading) {
            updateToken()
        }
        const interval = setInterval(() => {
            if (tokens) {
                updateToken()
            }

        }, thirtyMinute);
        return () => clearInterval(interval)
        // eslint-disable-next-line
    }, [tokens, loading])

    return (
        <LoginContext.Provider value={contextData}>
            {loading ? null : children}
        </LoginContext.Provider>
    )
}

export default LoginProvider
